export const environment = {
  production: true,
  urls: {
    getPublishersURL: '//stagingva.pubmatic.com/videotool/api/videotools/publisher',
    comparePublishersStatsURL: '//stagingva.pubmatic.com/videotool/api/videotools/publisher/stats',
    ortbValidator: '//stagingva.pubmatic.com/videotool/api/videotools/ortb/validate',
    dealReportsAPI: '//stagingva.pubmatic.com/videotool/api/videotools/dealReports',
    publisherComparisonPage: 'https://stagingva.pubmatic.com/ui/publisher.html',
    videoPlayerPage: 'https://stagingva.pubmatic.com/ui/index.html',
    testTagCreateApi:  '//stagingva.pubmatic.com/videotool/api/videotools/testTag/create',
    testTagGetApi: '//stagingva.pubmatic.com/videotool/api/videotools/testTag/list',
    downloadTagGetApi: '//stagingva.pubmatic.com/videotool/api/videotools/testTag/download',
    editTestTagApi: '//stagingva.pubmatic.com/videotool/api/videotools/testTag/edit',
    getCreativeScriptApi: '//stagingva.pubmatic.com/videotool/api/videotools/creative',
    translatorApi: '//stagingva.pubmatic.com/videotool/api/videotools/translator',
    comparePublisherSettingsApi: "https://stagingva.pubmatic.com/videotool/api/videotools/publisher/compare",
    comparePublisherStatsApi: "https://stagingva.pubmatic.com/videotool/api/videotools/publisher/stats",
  },
  okta: {
    clientId: '0oa1kxbant4Ca6V110h8',
    issuer: 'https://pubmatic.okta.com/oauth2/default',
    redirectUri: 'https://stagingva.pubmatic.com/videotool/login/callback',
    scopes: ['openid', 'profile', 'email'],
    pkce: false
  },
};
